<div class="row" style="width: 100%;">
  <div class="col-6 col-md-6" id="token">
    <div>
      <div class="stf-access-tokens">
        <div class="heading">
          <i class="fa fa-key"></i>
          <span>{{"Access Tokens" | translate}}</span>
          @if (disaplykeyGenarted) {
            <button class="btn pull-right btn-sm" (click)="creatKey()"
              title="Generate Access Token">
              <i class="fa fa-plus fa-fw"></i>
            </button>
          }
                    <a class="pull-right btn btn-sm" ng-href=""><i class="fa fa-question-circle" title="Access Token are used for Authenctication while Automation.
                         Create a Access Token for Automation"></i></a>
        </div>
        <div class="widget-content padded">
          <!-- after click access token -->
          @if (Noaccesstokens==true) {
            <div id="Noaccesstokens" class="ng-scope ng-isolate-scope">
              <div class="nothingshow">
                <span></span>
                <i class="fa fa-4x fa-key" ng-class="icon"></i>
                <p>{{"No access tokens" | translate}}</p>
              </div>
            </div>
          }
          <!-- //1Div before click access token-->
          @if (showToken) {
            <div id="showtoken">
              <div class="panel-heading">
                <h3 class="panel-title" style="text-align: center;">
                  <span>
                    {{"Generate Access Token" | translate}}
                  </span>
                </h3>
              </div>
              <div class="panel-body">
                <!-- <form class="form-horizontal" name="generateAccessTokenForm" (ngSubmit)="generateToken()"> -->
                <div class="container">
                  <label class="title">
                    <i class="fa fa-key fa-fw"> </i>
                    <span>
                      <span> {{"Title" | translate}}
                      </span>
                    </span>
                  </label>
                  <span class="token-error"></span>
                  <input #inputData id="access-token-title" type="text" name="accessTokenTitle"
                    maxlength="10" required text-focus-select class="form-control" required="">
                  <button type="submit" class="btn btn-primary-outline"
                    (click)="generateToken(inputData.value)"
                    style="border-color: darkturquoise; margin-left: 0;">
                    <i class="fa fa-plus fa-fw"></i>
                    <span>
                      <span class="ng-scope">{{"Generate New Token" | translate}}</span>
                    </span>
                  </button>
                </div>
              <!-- </form> -->
            </div>
          </div>
        }
        <!-- show token -->
        @if (showGeneratedtoken) {
          <div id="showGeneratedtoken" class="alert alert-info selectable">
            <strong>Warning:</strong>
            <span>&nbsp;</span>
            <span class="warnning">
              {{"Make sure to copy your access token now. You won't be able to see it again." | translate}}
            </span>
            <br>
              <button (click)="closeGenerated()" class="btn pull-right btn-primary btn-sm" title="Copy">
                <i class="fa fa-check fa-fw"></i>
              </button>
              <textarea readonly rows="2" text-focus-select class="form-control token-id-textarea">{{displayToken}}
              </textarea>
            </div>
          }
          <!-- list of keys  -->
          @if (copytoken) {
            <ul class="key-list" id="copytoken">
              @for (title of accessTokenTitles; track title) {
                <li class="list-group-item">
                  <a>
                    <i class="fa fa-key fa-2x fa-fw key-list-icon"></i>
                    <div class="key-list-details selectable">
                      <div class="key-list-title">{{ title }}</div>
                    </div>
                    <button class="btn btn-xs btn-danger-outline pull-right key-list-remove"
                      (click)="removeToken(title)">
                      <i class="fa fa-trash-o"></i>
                      <span translate>{{"Remove" | translate}}</span>
                    </button>
                  </a>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- let index = index" [@animateRepeat] -->